import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import "./text-elements.css";
import { AccountData } from "@/pages/accounts/schema/account.schema";

interface Props {
  accountData?: AccountData;
}

export const AccountMainDataCard = ({ accountData }: Props) => {
  return (
    <Flex flexDir="column" paddingX="12px" height="100%">
      <Text
        className="amd-card-title"
        paddingBottom="16px"
        textTransform={"uppercase"}
      >
        Datos de cuenta corriente
      </Text>
      <Grid templateColumns="repeat(2, 1fr)">
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-title-label">Cuenta:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-value-label">{accountData?.cuenta}</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-title-label">Razón social:</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-value-label">
            {accountData?.razonSocial}
          </Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-title-label">Tipo de cuenta:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-value-label">{accountData?.tipoCuenta}</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-title-label">Categoría de cuenta</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-value-label">
            {accountData?.categoriaCuenta}
          </Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-title-label">Localidad:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-value-label">{accountData?.localidad}</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-title-label">Zona comercial</Text>
        </GridItem>
        <GridItem
          paddingX="24px"
          paddingY="8px"
          backgroundColor={AppColors.BACKGROUND_SECONDARY}
        >
          <Text className="account-value-label">
            {accountData?.zonaComercial}
          </Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-title-label">Condición financiera:</Text>
        </GridItem>
        <GridItem paddingX="24px" paddingY="8px">
          <Text className="account-value-label">
            {accountData?.condicionFinanciera}
          </Text>
        </GridItem>
      </Grid>
    </Flex>
  );
};
